import { render } from "./ClientIntakeError.vue?vue&type=template&id=2cc1c51c&scoped=true"
import script from "./ClientIntakeError.vue?vue&type=script&lang=js"
export * from "./ClientIntakeError.vue?vue&type=script&lang=js"

import "./ClientIntakeError.vue?vue&type=style&index=0&id=2cc1c51c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc1c51c"]])

export default __exports__